import React, { ReactNode } from "react";

import { Box, SxProps } from "@mui/material";

import { theme } from "@/src/theme/theme";

export interface PageContainerProps {
  children?: ReactNode;
  maxWidth?: string;
  sx?: SxProps;
}

const PageContainer = (props: PageContainerProps) => (
  <Box
    sx={{
      width: "100%",
      maxWidth: props.maxWidth,
      backgroundColor: theme.palette.background.paper,
      p: [2, 3],
      ...props.sx
    }}
  >
    {props.children}
  </Box>
);

export default PageContainer;
